import React from "react";
import { Phone } from "lucide-react";

const PHONE = "01.84.16.20.60";
const PHONE_TEL = "tel:+33184162060";

export const MobileStickyCTA = () => (
  <a
    href={PHONE_TEL}
    data-testid="mobile-sticky-call-btn"
    className="md:hidden fixed bottom-4 left-4 right-4 z-40 inline-flex items-center justify-center gap-3 bg-[#FF5A1F] hover:bg-[#E04812] text-white font-black text-base px-6 py-4 rounded-full shadow-2xl"
  >
    <Phone className="w-5 h-5" strokeWidth={3} />
    Appeler — {PHONE}
  </a>
);

export default MobileStickyCTA;
